module.exports = __webpack_public_path__ + "img/trappers_hut_small.b8dec4b1.png";